module.exports = __webpack_public_path__ + "img/logo3.6d787852.png";